export const removeAllListParams = () => {
    Object.keys(localStorage).forEach((key) => {
        if (key.includes("listParams")) {
            localStorage.removeItem(key);
        }
    });
};